import { useId } from 'react';

// Laid out in the real card's own coordinates: 288x252 is a default cell, and the
// landmarks below are where OverviewCardV2 actually puts them — name at 14, chart
// 108 to 192, metric row from 192. No rule under the header; the card has none.
function DesignCardSVG() {
    const uid = useId();
    const id = (n) => `${n}-${uid.replace(/:/g, '')}`;

    return (
        <svg
            viewBox="0 0 288 252"
            width="100%"
            height="100%"
            preserveAspectRatio="none"
            aria-hidden
        >
            <g clipPath={`url(#${id('clip')})`}>
                <rect width="288" height="252" rx="6" fill="white" />

                {/* Name */}
                <rect
                    x="16"
                    y="17"
                    width="130"
                    height="14"
                    rx="4"
                    fill={`url(#${id('p0')})`}
                />
                {/* Parent category */}
                <rect
                    x="16"
                    y="40"
                    width="86"
                    height="11"
                    rx="3"
                    fill={`url(#${id('p1')})`}
                />

                {/* Life cycle badge */}
                <rect
                    x="181"
                    y="14"
                    width="91"
                    height="18"
                    rx="9"
                    fill={`url(#${id('p2')})`}
                />

                {/* Sparkline area */}
                <path
                    d="M0 150C24 143 48 132 72 136C96 140 120 122 144 116C168 110 192 118 216 122C240 126 264 114 288 108V192H0Z"
                    fill={`url(#${id('p3')})`}
                />

                {/* Metric row */}
                <rect y="192" width="288" height="60" fill="#FAFAFA" />
                <rect y="192" width="288" height="1" fill="#E9E9E9" />

                <rect
                    x="16"
                    y="206"
                    width="40"
                    height="13"
                    rx="4"
                    fill={`url(#${id('p4')})`}
                />
                <rect
                    x="16"
                    y="227"
                    width="52"
                    height="8"
                    rx="3"
                    fill={`url(#${id('p5')})`}
                />

                <rect x="96" y="192" width="1" height="60" fill="#F0F0F0" />

                <rect
                    x="112"
                    y="206"
                    width="36"
                    height="13"
                    rx="4"
                    fill={`url(#${id('p4')})`}
                />
                <rect
                    x="112"
                    y="227"
                    width="24"
                    height="8"
                    rx="3"
                    fill={`url(#${id('p5')})`}
                />

                <rect x="192" y="192" width="1" height="60" fill="#F0F0F0" />

                <rect
                    x="208"
                    y="206"
                    width="44"
                    height="13"
                    rx="4"
                    fill={`url(#${id('p4')})`}
                />
                <rect
                    x="208"
                    y="227"
                    width="50"
                    height="8"
                    rx="3"
                    fill={`url(#${id('p5')})`}
                />
            </g>
            <defs>
                <linearGradient
                    id={id('p0')}
                    x1="0"
                    y1="24"
                    x2="288"
                    y2="24"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F3F3F3" />
                    <stop offset="0.5" stopColor="#F8F8F8" />
                    <stop offset="1" stopColor="#F1F1F1" />
                </linearGradient>
                <linearGradient
                    id={id('p1')}
                    x1="0"
                    y1="45"
                    x2="120"
                    y2="45"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F3F3F3" />
                    <stop offset="0.5" stopColor="#F8F8F8" />
                    <stop offset="1" stopColor="#F1F1F1" />
                </linearGradient>
                <linearGradient
                    id={id('p2')}
                    x1="181"
                    y1="23"
                    x2="272"
                    y2="23"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F3F3F3" />
                    <stop offset="0.5" stopColor="#F8F8F8" />
                    <stop offset="1" stopColor="#F1F1F1" />
                </linearGradient>
                <linearGradient
                    id={id('p3')}
                    x1="0"
                    y1="150"
                    x2="288"
                    y2="150"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F3F3F3" />
                    <stop offset="0.5" stopColor="#FAFAFA" />
                    <stop offset="1" stopColor="#F3F3F3" />
                </linearGradient>
                <linearGradient
                    id={id('p4')}
                    x1="0"
                    y1="0"
                    x2="80"
                    y2="0"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F0F0F0" />
                    <stop offset="1" stopColor="#E8E8E8" />
                </linearGradient>
                <linearGradient
                    id={id('p5')}
                    x1="0"
                    y1="0"
                    x2="60"
                    y2="0"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F5F5F5" />
                    <stop offset="1" stopColor="#ECECEC" />
                </linearGradient>
                <clipPath id={id('clip')}>
                    <rect width="288" height="252" rx="6" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default DesignCardSVG;
